export default "__VITE_ASSET__uUA2hvUL__"